export default function HeroSection() {
  const handleScrollTo = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const target = document.querySelector(href);
    if (target) {
      const headerHeight = 64;
      const targetPosition = target.getBoundingClientRect().top + window.pageYOffset - headerHeight;
      window.scrollTo({ top: targetPosition, behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      className="relative w-full min-h-[600px] md:min-h-[680px] flex items-center overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20dramatic%20cinematic%20abstract%20background%20with%20deep%20red%20and%20dark%20tones%2C%20subtle%20newsroom%20texture%20with%20soft%20spotlight%20effects%2C%20editorial%20atmosphere%2C%20warm%20gradients%20from%20dark%20crimson%20to%20deep%20charcoal%2C%20mysterious%20and%20compelling%20mood&width=1800&height=800&seq=hero-bg&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-background-50"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-20 md:py-0">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 bg-primary-500/20 backdrop-blur-sm border border-primary-400/30 rounded-full px-4 py-1.5 mb-6">
              <span className="w-2 h-2 rounded-full bg-accent-500 animate-pulse"></span>
              <span className="text-xs md:text-sm font-medium text-primary-100 whitespace-nowrap">
                今日更新 386 条 · 全网最新黑料爆料
              </span>
            </div>

            <h1 className="font-heading text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-black text-white leading-tight mb-4">
              黑料爆料
              <span className="block text-accent-400 text-xl sm:text-2xl md:text-3xl lg:text-4xl font-semibold mt-2">
                全网热门黑料爆料第一站
              </span>
            </h1>

            <p className="text-white/70 text-sm md:text-base leading-relaxed max-w-xl mx-auto lg:mx-0 mb-4">
              娱乐圈水深不见底，我们帮你一探究竟。黑料爆料每日追踪最新黑料爆料与热点事件，从明星塌房到综艺内幕，从网红翻车到行业潜规则——我们不做标题党，只做实锤党。每天更新数百条爆料，吃瓜群众的第一手信息来源。
            </p>
            <p className="text-white/50 text-xs md:text-sm leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8">
              本周焦点：选秀节目黑幕调查持续深入，多名知情人主动联系本平台提供关键证据，预计未来一周将有多项重磅实锤陆续发布。敬请锁定黑料爆料每日大赛，不错过任何一个大瓜。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-white font-heading">2000+</div>
                <div className="text-xs text-white/50 mt-1">独家深度报道</div>
              </div>
              <div className="w-px h-10 bg-white/20 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-accent-400 font-heading">98.7%</div>
                <div className="text-xs text-white/50 mt-1">信息真实率</div>
              </div>
              <div className="w-px h-10 bg-white/20 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-white font-heading">300万+</div>
                <div className="text-xs text-white/50 mt-1">日活吃瓜群众</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#cards"
                onClick={(e) => handleScrollTo(e, '#cards')}
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-primary-500 hover:bg-primary-600 text-white font-semibold px-8 py-3.5 rounded-full text-sm transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-flashlight-line"></i>
                立即吃瓜
              </a>
              <a
                href="#ranking"
                onClick={(e) => handleScrollTo(e, '#ranking')}
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-white/10 hover:bg-white/20 text-white border border-white/30 font-medium px-8 py-3.5 rounded-full text-sm transition-all duration-200 whitespace-nowrap cursor-pointer backdrop-blur-sm"
              >
                <i className="ri-fire-line"></i>
                查看热榜
              </a>
            </div>
          </div>

          <div className="flex-1 w-full hidden lg:flex items-center justify-center">
            <div className="relative w-full max-w-lg">
              <div className="absolute -inset-4 bg-primary-500/10 rounded-3xl blur-2xl"></div>
              <img
                src="https://readdy.ai/api/search-image?query=A%20dramatic%20editorial%20magazine%20cover%20style%20composition%2C%20breaking%20news%20aesthetic%20with%20warm%20red%20and%20gold%20accents%2C%20mysterious%20silhouette%20figures%2C%20dramatic%20spotlight%20effect%2C%20cinematic%20atmosphere%2C%20news%20media%20visual%20style&width=800&height=700&seq=hero-main&orientation=portrait"
                alt="黑料爆料 - 全网热门黑料爆料与最新黑料爆料每日大赛排行"
                className="relative w-full h-auto rounded-2xl"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}